<template lang="pug">
  div.not-subsribe-footer
    div.footer1
      div.left
        div.item
          div.title 关于我们
          a.block 咨询合作
          a.block(href="https://www.zhiweidata.com/" target="_blank") 关于知微
          a.block(href="https://www.zhiweidata.com/aboutus/" target="_blank") 相关产品
        div.item
          div.title 舆情洞察
          a.block(href="https://trends.zhiweidata.com/historyList" target="_blank") 热点榜
          a.block(href="https://ef.zhiweidata.com/library" target="_blank") 事件榜
        div.item
          div.title 友情链接
          a.block(href="https://trends.zhiweidata.com/" target="_blank") 知微舆论场
          a.block(href="https://ef.zhiweidata.com/" target="_blank") 知微事见
          a.block(href="https://eventgraph.zhiweidata.com/" target="_blank") 事件传播图谱
      div.right
        div.title 咨询合作
        div.content
          div.item
            img.qrcode(src="../assets/img/index/qrcode.png")
            p 微信客服
          div.item
            img(src="../assets/img/index/公众号.png")
            p 微信公众号
    div.footer2
      div.contact
        p ©2012-{{year}} zhiweidata.com
        p
          img(src="../assets/img/copy_right.png")
          span 备案京ICP备13015804号
      div.contact
        p 联系电话： 400-811-3709
        p 网址：www.zhiweidata.com
      div.contact
        p 微博：@社会网络与数据挖掘
        p 邮箱：zhiwei@zhiweidata.com
      div.contact
        p 微信客服号：zhiwei_data
        p QQ客服号：2406163039
</template>

<script>
export default {
  name: 'NotSubsribeFooter',
  data () {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>

<style lang="scss" scoped>
.not-subsribe-footer {
  padding: 0 10%;
  height: 280px;
  color: #fff;
  a {
    color: #fff;
  }
  .title {
    font-weight: bold;
    font-size: 16px;
  }
  .footer1 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 180px;
    border-bottom: 1px solid #3f5285;
    .left {
      display: flex;
      .item {
        margin-right: 50px;
        text-align: center;
        .title {
          font-size: 15px;
        }
        .block {
          display: block;
          margin-top: 15px;
          font-size: 12px;
        }
      }
    }
    .right {
      .content {
        display: flex;
        margin-top: 15px;
      }
      .item {
        margin: 5px 0 0 45px;
        &:first-child {
          margin-left: 0;
        }
        text-align: center;
      }
      .qrcode {
        width: 54px;
        height: 54px;
      }
    }
  }
  .footer2 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    height: 100px;
    .contact {
      p {
        margin: 10px 0;
        display: flex;
        align-items: center;
        img {
          margin-right: 5px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/EventIndex/NotSubsribeFooter.vue